module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-economic-group/bc-economic-group.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-economic-group/bc-economic-group.component.scss
// module chunks = main